import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStaffService } from '../../../../apis/staff/useStaffService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TAttendanceByDateResponse } from '../../../../apis/__shared/attendance.interfaces';
import { Dayjs } from 'dayjs';

type TQueryError = IFHError<{ message: string }>;
export const getStaffAttendanceByDateKey = 'get-staff-attendance-by-date';

export const useStaffAttendanceHook = (
  params: TPaginationParams,
  dateRange: { fromDate: Dayjs | null; toDate: Dayjs | null },
  options?: UseQueryOptions<TAttendanceByDateResponse, TQueryError>
): UseQueryResult<TAttendanceByDateResponse, TQueryError> => {
  const { getStaffAttendanceByDate } = useStaffService();

  const queryKey = [getStaffAttendanceByDateKey, params, dateRange];

  return useQuery<TAttendanceByDateResponse, TQueryError>({
    queryKey,
    queryFn: () => getStaffAttendanceByDate(params, dateRange),
    enabled: true,
    ...options,
  });
};
